// Cart drawer close
const closeCartPopup = () => {
  document.querySelector(".cart-drawer .side-panel-close").click();
}
// Cart drawer close

document
  .querySelectorAll(".cycs-options-wrap .cycs-ow-option")
  .forEach((item) => {
    item.addEventListener("click", function () {
      removeActiveclass(".cycs-options-wrap .cycs-ow-option");
      // removeBGColor();
      this.classList.add("active");
      const imageSrc = this.dataset.src;
      const imageTitle = this.dataset.title;
      const imageSubtext = this.dataset.subtext;
      const imageText = this.dataset.text;
      const bgcolor = this.dataset.color;
      const fontColor = this.dataset.fontcolor;
      if (imageSrc) {
        // document.querySelector(".cycs-image-wrapper img").src = imageSrc;
        document
          .querySelectorAll(".cycs-image-wrapper")
          .forEach((itemImage) => {
            itemImage.querySelector("img").src = imageSrc;
          });
      }
      document.querySelector(".cycs-content-wrapper .cycs-title").innerHTML = imageTitle;
      if (imageSubtext) {
        document.querySelector(".cycs-content-wrapper .cycs-subtext").innerHTML = imageSubtext;
      }
      if (imageText) {
        document.querySelector(".cycs-content-wrapper .cycs-text").innerHTML = imageText;
      }

      console.log("bgcolor ", bgcolor);
      item.closest(".cycs-section").style.backgroundColor = bgcolor;
      // item.style.backgroundColor = bgcolor;
      item
        .closest(".cycs-content-wrapper")
        .style.setProperty("--option-fontcolor", fontColor);
    });
  });

document
  .querySelectorAll(".cyfs-options-wrap .cyfs-ow-option")
  .forEach((item, index) => {
    item.addEventListener("click", function () {
      console.log('index ',index);
      removeActiveclass(".cyfs-options-wrap .cyfs-ow-option");
      this.classList.add("active");
      const imageSrc = this.dataset.src;
      const imageTitle = this.dataset.title;
      const imageText = this.dataset.text;
      filterCompareDetails(index);
      if (imageSrc) {
        document.querySelector(".cyfs-image-wrapper img").src = imageSrc;
      }
      document.querySelector(".cyfs-content-wrapper .cyfs-title").innerHTML =
        imageTitle;
      document.querySelector(".cyfs-content-wrapper .cyfs-text").innerHTML =
        imageText;
    });
  });


const filterCompareDetails = (index) => {
  document.querySelectorAll('.filter-details-wrap .fdw-wrap').forEach(item => {
    item.classList.remove('active');
  });
  document.querySelector(`.filter-details-wrap .fdw-wrap[data-index="${index}"]`).classList.add('active');
}

 document.querySelectorAll('.filter-details-wrap .fdw-wrap').forEach((item, index) => {
     item.addEventListener('click', function(){
         $('.cyfs-options-wrap .cyfs-ow-option').eq(index).click();
     });
 });

const removeActiveclass = (cclass) => {
  document.querySelectorAll(cclass).forEach((item) => {
    item.classList.remove("active");
  });
};

const removeBGColor = () => {
  document
    .querySelectorAll(".cycs-options-wrap .cycs-ow-option")
    .forEach((item) => {
      item.style.backgroundColor = "#fff";
    });
};


document.addEventListener("DOMContentLoaded", function () {
  const faqQuestions = document.querySelectorAll(".faq-question");

  faqQuestions.forEach((question) => {
    question.addEventListener("click", function () {
      this.classList.toggle("active");

      // const answer = this.nextElementSibling;
      // if (answer.style.display === "block") {
      //   answer.style.display = "none";
      // } else {
      //   answer.style.display = "block";
      // }
    });
  });
});

window.updateCartIconPrice = () => {
  const amout_no_deciaml = document.querySelector('body').dataset.marketCurrency+'{{amount}}';
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((result) => {
      document.querySelector(
        "#cart-drawer-togglee .thb-items-price"
      ).innerHTML = Shopify.formatMoney(
        result.total_price,
        amout_no_deciaml
      ).replace(".00", "");
    })
    .catch((error) => console.error("Error fetching JSON data:", error));
};


/* auto-refile subscription */
document.querySelectorAll(".csw-sub-onetime .csw-type-wrap").forEach((item) => {
  item.addEventListener("click", function () {
    if (!this.classList.contains("active")) {
      document
        .querySelectorAll(".csw-sub-onetime .csw-type-wrap")
        .forEach((itemm) => {
          itemm.classList.remove("active");
        });
      this.classList.add("active");
      window.updateVariantSellingPlanPrice();
    }
  });
});
/* end auto-refile subscription */

document.querySelectorAll('.pfi-options-wrap.filter .pfi-filter-block input').forEach(filter => {
   filter.addEventListener('change', function(){
       const checkedFilter = document.querySelector('.pfi-options-wrap.filter .pfi-filter-block input:checked');
       document.querySelector('.pfi-options-wrap.filter .pfi-filter-block.active').classList.remove('active');
       checkedFilter.closest('.pfi-filter-block').classList.add('active');
   });
});

// /* change choose your filter content */

// document
//   .querySelectorAll(
//     'fieldset.product-form__input[data-handle="choose-your-filter"] input'
//   )
//   .forEach((item) => {
//     item.addEventListener("change", function () {
//       const optionname = this.value;
//       document
//         .querySelectorAll(".option-description-wrapper .fiter-option-desc")
//         .forEach((desc) => {
//           desc.classList.remove("active");
//         });
//       document
//         .querySelector(
//           `.option-description-wrapper .fiter-option-desc[data-option="${optionname}"]`
//         )
//         .classList.add("active");
//     });
//   });

/* custom tab js */

document.querySelectorAll('.ctw-cw-tabs .ctw-cw-btnwrap').forEach(item => {
    item.addEventListener('click', function(){
        if(!this.classList.contains('active')){
            document.querySelectorAll('.ctw-cw-tabs .ctw-cw-btnwrap').forEach(tab => {
                tab.classList.remove('active'); 
            });
            this.classList.add('active');
            const tabText = this.dataset.text;
            const tabName = this.dataset.title;
            document.querySelectorAll('.ctw-cw-content-wrap .ctw-cw-content').forEach(tab => {
                tab.classList.remove('active'); 
            });
            document.querySelector(`.ctw-cw-content-wrap .ctw-cw-content[data-title="${tabName}"]`).classList.add('active');
            this.closest('.ctw-wrapper').querySelector('.section-header--description').innerHTML = tabText;
            
            // Clear existing timeout if any
            if (window.tabTimeout) {
                clearTimeout(window.tabTimeout);
            }
            //tabProcessSlider();
        }
    });
});

const tabProcessSlider = () => {
    window.tabTimeout = setTimeout(function(){
        const tabButtons = document.querySelectorAll('.ctw-cw-tabs .ctw-cw-btnwrap');
        const activeTabButton = document.querySelector('.ctw-cw-tabs .ctw-cw-btnwrap.active');
        const tabLength = tabButtons.length - 1;
        const index = parseInt(activeTabButton.dataset.index);
        let nextIndex = index;
        if(tabLength > index){
            nextIndex += 1;
        }else{
            nextIndex = 0;
        }
        document.querySelector(`.ctw-cw-tabs .ctw-cw-btnwrap[data-index="${nextIndex}"]`).click();
    }, 6000);
}

document.querySelectorAll('fieldset.product-form__input[data-handle="choose-your-color"] input').forEach(input => {
   input.addEventListener('change', function(){
      const colorName = this.value.toLowerCase();
      if(colorName != 'purely white'){
        console.log('non white');
        document.querySelector('fieldset.product-form__input[data-handle="choose-your-filter"] input[value="The 🤯 Overreactor."]').click();
      }
   });
});

const atcBtn = document.querySelector('button.single-add-to-cart-button');
if(atcBtn){
  document.querySelector('button.single-add-to-cart-button').addEventListener('click', async function(){
      const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartJson = await cartRes.json();
      this.classList.add('loading');
      const form = this.closest('form');
      addtocart(form);
  });
}

// function newcrpButtonClick(button){
//   button.classList.add('loading');
//   const form = button.closest('form'); 
//   addtocart(form);
// }

function newcrpButtonClick(button){
  button.classList.add('loading');
  const form = button.closest('form');
  const main_vid = form.querySelector('input[name="id"]').value;
  let formDatacus = {'items': [{'id': main_vid,'quantity': 1}]};
  const has_auto_filter = form.querySelector('input[name="addon-id"]');
  
  if(has_auto_filter){
    const filter_id = has_auto_filter.value;
    const filter_sellingplan_id = has_auto_filter.getAttribute('data-sellingid');
    if(filter_sellingplan_id){
        formDatacus.items.push({'id': filter_id,'quantity': 1, 'selling_plan': filter_sellingplan_id, properties: {'__main_product_id': main_vid}});
      }else{
        formDatacus.items.push({'id': filter_id,'quantity': 1, properties: {'__main_product_id': main_vid}}); 
      }
  }
  
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(formDatacus)
    })
    .then(response => {
      // console.log('response ',response);
      window.cartUpdate();
      setTimeout(function() {
        document.querySelector('button.single-add-to-cart-button').classList.remove('loading');
      },1000);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function crpMakeVariantSelected(item ,vid){
  const hasActiveslide = item.closest('.slick-slide').classList.contains('slick-current');
  console.log('hasActiveslide ',hasActiveslide);
  if(hasActiveslide){
    const varientTitle = document.querySelector(`select.combine-variants-wrap option[value="${vid}"]`).dataset.title;
    const optionArr = varientTitle.split(' / ');
    optionArr.forEach(function(element) {
        console.log(element);
        document.querySelector(`.product-form__input input[value="${element}"]`).click();
    });
    document.querySelector('.cart-drawer side-panel-close.side-panel-close').click();
  }
}


function addtocart(form){
  const formData = new FormData(form);
      const formObject = {};
      formData.forEach((value, key) => {
          if (formObject[key]) {
              if (!Array.isArray(formObject[key])) {
                  formObject[key] = [formObject[key]];
              }
              formObject[key].push(value);
          } else {
              formObject[key] = value;
          }
      });
      const qtySelector = document.querySelector('.new-quantity-grid-item input:checked');
      const newQty = qtySelector ? qtySelector.value : formObject.quantity;
      let formDatacus = {'items': []};
      //console.log(formDatacus);
  
      
      /* sock adding */
      const sockSelector = document.querySelector('.add-a-sock-grid-item input:checked');
      if(sockSelector && sockSelector.value == 'yes'){
        const sockId = sockSelector.dataset.id;
        if(sockId){formDatacus.items.push({'id': sockId,'quantity': 1,properties: {'__mainn_product_id': formObject.id, '__sock': 'yes'}})}
      }

      const combineOption = document.querySelector(`select.combine-variants-wrap option[value="${formObject.id}"]`);
      const fsid = combineOption.dataset.fsid;
      const fsellingid = combineOption.dataset.fsellingid;
      /* filter subscriptio adding */
      if(fsid){formDatacus.items.push({'id': fsid,'selling_plan':fsellingid,'quantity': newQty,properties: {'__main_product_id': formObject.id}})}

      /* main product adding */
       formDatacus.items.push({'id': formObject.id,'quantity': newQty});
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formDatacus)
      })
      .then(response => {
        //console.log('response ',response);
        window.cartUpdate();
        setTimeout(function() {
          document.querySelector('button.single-add-to-cart-button').classList.remove('loading');
        },1000);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
}

window.cartUpdate = () => {
    const form = document.querySelector('.product-form');
   fetch(window.Shopify.routes.root + 'cart?query=mini')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      // console.log(data);
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cartDrawer = doc.getElementById('Cart-Drawer');
      const cartDrawerHTML = cartDrawer.innerHTML;
      const cartDprice = doc.querySelector('.thb-items-price').innerHTML;
      
      document.querySelector('#Cart-Drawer').innerHTML = cartDrawerHTML;
      document.querySelector('.thb-items-price').innerHTML = cartDprice;

      $('.cart-rp-wrapper').slick({infinite: false, slidesToShow: 1,slidesToScroll: 1,arrows: true,dots: false});
      pairwithDisabled();
      
      let product_drawer = document.getElementById("Product-Drawer"),
        search_drawer = document.getElementById("Search-Drawer");
  
      if (search_drawer.classList.contains("active")) {
        search_drawer.classList.remove("active");
      }
      if (product_drawer && product_drawer.contains(form)) {
        product_drawer.classList.remove("active");
        form.body.classList.remove("open-cc--product");
        if (document.getElementById("Cart-Drawer")) {
          form.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
        }
      } else if (document.getElementById("Cart-Drawer")) {
        form.body.classList.add("open-cc");
        document.getElementById("Cart-Drawer").classList.add("active");
        dispatchCustomEvent("cart-drawer:open");
      }
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
}

function qtyPlusMinus(button){
    const bType = button.dataset.type;
    const input = button.closest('.custom-quantity').querySelector('input');
    const qty = parseInt(input.value);
    const line = input.dataset.line;
    const vid = input.dataset.vid;
    button.disabled = true;
    button.closest('.product-cart-item').classList.add('thb-loading');
     if(bType == 'plus'){
         input.value = qty + 1;
         updateCartItem(line, qty + 1,vid);
     }else{
       if(qty >= 2){
        input.value = qty - 1;
        updateCartItem(line, qty - 1,vid);
       }
     }
}

function removeItem(rbtn){
  const line = rbtn.dataset.line;
  const vid = rbtn.dataset.vid;
  rbtn.closest('.product-cart-item').classList.add('thb-loading');
  updateCartItem(line, 0,vid);
}

async function updateCartItem(line, qty, vid){
  const cartReq = await fetch(window.Shopify.routes.root + 'cart.js');
  const cartJson = await cartReq.json();
  const cartItem = cartJson.items;
  const hasFreeItem = cartItem.filter(item => item.properties?.__main_product_id == vid);
  
  console.log('hasFreeItem ',hasFreeItem);
  let formData = {'line': line,'quantity': qty};
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(formData)
  })
  .then(response => {
    if(hasFreeItem.length > 0){
      updateCartItemFilter(hasFreeItem[0].key,qty);
    }else{
      window.cartUpdate();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateCartItemFilter(id, qty){
  let formData = {'id': id,'quantity': qty};
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.cartUpdate();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

/* custom cart drawer js */
// const pspPrice = document.querySelector('select.combine-variants-wrap option:first-child').dataset.price;
// document.querySelector('.thb-secondary-item-icon .thb-items-price').innerHTML = pspPrice;

// document.querySelector('.thb-custom-drawer').addEventListener('click', function(){
//    this.classList.toggle('active');
//    document.querySelector('.cart-dropdown-overlay').classList.toggle('active');
// });

// document.querySelector('.cart-dropdown-overlay').addEventListener('click', function(){
//    document.querySelector('.thb-custom-drawer').classList.toggle('active');
//    document.querySelector('.cart-dropdown-overlay').classList.toggle('active');
// });

// window.customcartUpdate();

/* jquery code start here */

$('.iwts--carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});

$('.cw-slider-wrap').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
});

$('.cw-slider-mobile-wrap').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    draggable: false,
    touchMove: false,
    swipe: false
});

var selectBox = document.querySelector('.cw-wrapper-mobile select.cw-dropdown');
selectBox.addEventListener('change', function(){
    const comname = this.value;
    var selectedOption = selectBox.options[selectBox.selectedIndex];
    var dataIndexValue = selectedOption.getAttribute('data-index');
    console.log('comname ',comname);
    $('.cw-slider-mobile-wrap').slick('slickGoTo', dataIndexValue);
});

$('.cart-rp-wrapper').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false
  });

// function filterTrigger(foption){
//   const title = foption.dataset.ptitle;
//   document.querySelectorAll('.product-form__input[data-handle="choose-your-filter"] input').forEach(option => {
//     const optionName = option.value.toLowerCase();
//      if(optionName.indexOf(title) > -1){
//          option.click();
//          if(title != 'overreactor'){
//            document.querySelector('.product-form__input[data-handle="choose-your-color"] input:first-child').click();
//          }
//          document.querySelector('.side-panel-close').click();
//      }
//   });
// }


let country_code = document.querySelector('.shopify-localization-form input[name="country_code"]').value;
console.log('country_code ',country_code);
preorderCounteryWise();
pairwithDisabled();

// $.get("https://ipinfo.io", function(response) {
//     console.log(response.country+'--test');
//     country_code = response.country;
//     document.querySelectorAll('button.single-add-to-cart-button')[0].disabled = false;
//     preorderCounteryWise();
//     pairwithDisabled();
// }, "jsonp");


function preorderCounteryWise(){
  // Remove the "preorder_now" class from the body
  document.body.classList.remove("preorder_now");
  
  const vid = document.querySelector('product-form.product-form form input[name="id"]')?.value;
  const sku = document.querySelector(`select.combine-variants-wrap option[value="${vid}"]`)?.dataset.sku;
  const vavl = document.querySelector(`select.combine-variants-wrap option[value="${vid}"]`)?.dataset.avl;
  console.log('sku ', sku);

  // Ensure `this.currentVariant` is defined
  if (vid) {
    // Check for Canada SKU and availability
    if (canada_sku.includes(sku)) {
      if (country_code === 'CA') {
        setTimeout(() => {
          document.body.classList.add("preorder_now");
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Preorder Now';
          }
        }, 0);
      }
    }
    // Check for US SKU and availability
    if (us_sku.includes(sku)) {
      if (country_code === 'US') {
        setTimeout(() => {
          document.body.classList.add("preorder_now");
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Preorder Now';
          }
        }, 0);
      }
    }

    console.log('country_code ',country_code);
    if (canada_sku_oos.includes(sku)) {
      if (window.location.pathname.includes('en-ca') || country_code === 'CA') {
        setTimeout(() => {
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Out Of Stock';
            document.querySelector('button.single-add-to-cart-button').disabled = true;
          }
        }, 0);
      }
    }
    
    if (us_sku_oss.includes(sku)) {
      if (country_code === 'US') {
        setTimeout(() => {
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Out Of Stock';
            document.querySelector('button.single-add-to-cart-button').disabled = true;
          }
        }, 0);
      }
    }

    if (uk_sku.includes(sku)) {
      if (country_code === 'GB') {
        setTimeout(() => {
          document.body.classList.add("preorder_now");
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Preorder Now';
          }
        }, 0);
      }
    }

    if (uk_sku_oos.includes(sku)) {
      if (country_code === 'GB') {
        setTimeout(() => {
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Out Of Stock';
            document.querySelector('button.single-add-to-cart-button').disabled = true;
          }
        }, 0);
      }
    }
    
  } else {
    console.error('currentVariant is undefined or null.');
  }
};

function pairwithDisabled(){
  document.querySelectorAll('#Cart-Drawer .crp-item button.crp-atc').forEach(crpButton => {
      const sku = crpButton.dataset.sku;
  
      if (canada_sku_oos.includes(sku)) {
          if (country_code === 'CA') {
              crpButton.disabled = true;
          }
      }
  
      if (us_sku_oss.includes(sku)) {
          if (country_code === 'US') {
              crpButton.disabled = true;
          }
      }
  });
}